import { FieldValidator } from '@ov-suite/helpers-angular';
import { UserModel } from '@ov-suite/models-idm';
import { OvAutoService } from '@ov-suite/services';
import gql from 'graphql-tag';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class UsernameValidator implements FieldValidator<UserModel> {
  errorMessage = 'Username already In Use';

  constructor(private readonly ovAutoService: OvAutoService) {}

  async validateCreate(user: UserModel): Promise<boolean> {
    if (!user.username) {
      return false;
    }
    return firstValueFrom(
      this.ovAutoService.apollo.query<boolean>({
        query: gql(`query checkUsernameExists($username: String!) {
          checkUsernameExists(username: $username)
        }`),
        variables: {
          username: user.username,
        },
      }),
    ).then(res => !res.data['checkUsernameExists']);
  }

  async validateUpdate(): Promise<boolean> {
    return true;
  }

  async required(): Promise<boolean> {
    return true;
  }
}
